/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { resourceSchema } from './resourceSchema';

export const pageResponseResourceSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(resourceSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
